<h2 mat-dialog-title>
  {{ data.meeting.isChangeRequest ? 'Decline proposed changes?' : 'Deny meeting request?' }}
</h2>
<mat-dialog-content>
  <p class="deny-context">{{ data.meeting.studentName }} &bull; {{ data.meeting.title }}</p>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Reason (optional)</mat-label>
    <textarea
      data-testid="deny-reason-input"
      matInput
      [formControl]="noteControl"
      rows="3"
      [placeholder]="reasonPlaceholder"
    ></textarea>
    <mat-hint>Leave blank to use: "{{ defaultMessage }}"</mat-hint>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button data-testid="cancel-deny-btn" mat-button type="button" (click)="dialogRef.close()">
    Cancel
  </button>
  <button
    data-testid="confirm-deny-btn"
    mat-flat-button
    color="warn"
    type="button"
    (click)="confirm()"
  >
    Deny
  </button>
</mat-dialog-actions>
